import { complement, isNil, values } from 'ramda';
import { extent } from 'd3-array';
import { intervalLengthMonths, isTimeInterval } from './time';
import { scaleSqrt } from 'd3-scale';
import { gradients } from '../theme';

export const isPresent = complement(isNil);

export const capitalize = string =>
  string.charAt(0).toUpperCase() + string.slice(1);

export const sortTypeAware = (a, b) => {
  if (typeof a !== typeof b) {
    throw Error(`Trying to sort different types ${typeof a} ${typeof b}`);
  }

  switch (typeof a) {
    case 'string':
      return isTimeInterval(a)
        ? intervalLengthMonths(b) - intervalLengthMonths(a)
        : a === b ? 0 : a < b ? -1 : 1;
    case 'number':
      return b - a;
    default:
      return 0;
  }
};

export const pending = actionType => actionType + '_PENDING';
export const fulfilled = actionType => actionType + '_FULFILLED';
export const rejected = actionType => actionType + '_REJECTED';

export const getColorScale = (min, max) =>
  scaleSqrt()
    .domain(min < 0 ? [min, 0, max] : [min, max])
    .range(min < 0 ? gradients.compare : gradients.absolute);

/**
 * Outputs min and max values of the provided dataset
 * ensuring that if min < 0, Math.abs(min) === Math.abs(max)
 *
 * @param {number[]} data - dataset
 */
export const getExtent = data => {
  const vals = values(data);

  if (vals.length === 0) return [0, 0];

  const [min, max] = extent(vals);

  if (min < 0) {
    const maxAbs = Math.max(Math.abs(min), Math.abs(max));
    return [-maxAbs, maxAbs];
  } else {
    return [0, max];
  }
};



// WEBPACK FOOTER //
// ./src/utils/helpers.js